import { Box, Button, Card, Flex, Heading, Separator, Text, Theme } from '@workos-inc/design-system';
import * as React from 'react';
import { Demo } from './demo';
import { DemoForm } from './demo-form';
export const SsoDemoSignInWithSso = () => <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="SsoDemoSignInWithSso" data-sentry-source-file="sso-demos.tsx">
    <Demo.Container data-sentry-element="Demo.Container" data-sentry-source-file="sso-demos.tsx">
      <SsoSignInWithSso data-sentry-element="SsoSignInWithSso" data-sentry-source-file="sso-demos.tsx" />
    </Demo.Container>
    <Demo.Caption data-sentry-element="Demo.Caption" data-sentry-source-file="sso-demos.tsx">
      Try signing with credentials, then using Single Sign-On with any{' '}
      <strong>@foo-corp.com</strong> email.
    </Demo.Caption>
  </Demo.Root>;
export const SsoDemoSeparateFields = () => <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="SsoDemoSeparateFields" data-sentry-source-file="sso-demos.tsx">
    <Demo.Container data-sentry-element="Demo.Container" data-sentry-source-file="sso-demos.tsx">
      <SsoSeparateFields data-sentry-element="SsoSeparateFields" data-sentry-source-file="sso-demos.tsx" />
    </Demo.Container>
    <Demo.Caption data-sentry-element="Demo.Caption" data-sentry-source-file="sso-demos.tsx">
      Try signing in with any <strong>@foo-corp.com</strong> email vs.
      credentials.
    </Demo.Caption>
  </Demo.Root>;
export const SsoDemoDynamicPasswordField = () => <Demo.Root data-sentry-element="Demo.Root" data-sentry-component="SsoDemoDynamicPasswordField" data-sentry-source-file="sso-demos.tsx">
    <Demo.Container style={{
    minHeight: 450
  }} data-sentry-element="Demo.Container" data-sentry-source-file="sso-demos.tsx">
      <SsoDynamicPasswordField data-sentry-element="SsoDynamicPasswordField" data-sentry-source-file="sso-demos.tsx" />
    </Demo.Container>
    <Demo.Caption data-sentry-element="Demo.Caption" data-sentry-source-file="sso-demos.tsx">
      Try signing in with any <strong>@foo-corp.com</strong> email vs.
      credentials.
    </Demo.Caption>
  </Demo.Root>;
const SsoSignInWithSso = () => {
  const [loading, setLoading] = React.useState(false);
  const [screen, setScreen] = React.useState<'initial' | 'sso' | 'sso-redirect' | 'password-success'>('initial');
  const handleRestart = () => setScreen('initial');
  if (screen === 'initial') {
    return <ChromeUI>
        <DemoForm.Root onSubmit={event => {
        const formData = new FormData(event.currentTarget);
        // Introducing lint rule banning type assertions
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const email = formData.get('email') as string | null;
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          if (isFooCorpEmail(email ?? '')) {
            setScreen('sso-redirect');
          } else {
            setScreen('password-success');
          }
        }, 1000);
        event.preventDefault();
      }}>
          <Flex direction="column" gap="5">
            <Heading trim="start">Sign in to Demo App</Heading>
            <DemoForm.Field name="email">
              <DemoForm.Label>Email</DemoForm.Label>
              <DemoForm.Input required placeholder="Enter email address" type="email" />
              <DemoForm.Message match="valueMissing">
                Email is required
              </DemoForm.Message>
              <DemoForm.Message match="typeMismatch">
                Email should be valid.
              </DemoForm.Message>
            </DemoForm.Field>

            <DemoForm.Field name="password">
              <DemoForm.Label>Password</DemoForm.Label>
              <DemoForm.Input required placeholder="Enter password" type="password" />
              <DemoForm.Message match="valueMissing">
                Password is required
              </DemoForm.Message>
            </DemoForm.Field>

            <DemoForm.Submit loading={loading}>Continue</DemoForm.Submit>
          </Flex>
        </DemoForm.Root>

        <Separator my="5" size="4" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
          <Box mt="-1" px="2" style={{
          backgroundColor: 'var(--color-panel-solid)'
        }}>
            <Text color="gray">or</Text>
          </Box>
        </Separator>

        <Button color="gray" loading={loading} size="3" style={{
        width: '100%'
      }} onClick={() => setTimeout(() => {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          setScreen('sso');
        }, 1000);
      })}>
          Use Single Sign-On
        </Button>
      </ChromeUI>;
  }
  if (screen === 'sso') {
    return <ChromeUI>
        <DemoForm.Root onSubmit={event => {
        const formData = new FormData(event.currentTarget);
        // Introducing lint rule banning type assertions
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const email = formData.get('email') as string | null;
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          if (isFooCorpEmail(email ?? '')) {
            setScreen('sso-redirect');
          } else {
            setScreen('initial');
          }
        }, 1000);
        event.preventDefault();
      }}>
          <Flex direction="column" gap="5">
            <Heading trim="start">Sign in to Demo App</Heading>

            <DemoForm.Field name="email">
              <DemoForm.Label>Email</DemoForm.Label>
              <DemoForm.Input autoFocus required placeholder="Enter your corporate email" type="email" />
              <DemoForm.Message match="valueMissing">
                Email is required
              </DemoForm.Message>
              <DemoForm.Message match="typeMismatch">
                Email should be valid.
              </DemoForm.Message>
            </DemoForm.Field>

            <DemoForm.Submit loading={loading}>Continue</DemoForm.Submit>
          </Flex>
        </DemoForm.Root>
      </ChromeUI>;
  }
  if (screen === 'password-success') {
    return <PasswordEndScreen onRestart={handleRestart} />;
  }
  if (screen === 'sso-redirect') {
    return <SsoEndScreen onRestart={handleRestart} />;
  }
  return null;
};
const SsoSeparateFields = () => {
  const [loading, setLoading] = React.useState(false);
  const [screen, setScreen] = React.useState<'email' | 'password' | 'sso-redirect' | 'password-success'>('email');
  const handleRestart = () => setScreen('email');
  if (screen === 'email') {
    return <ChromeUI>
        <DemoForm.Root onSubmit={event => {
        const formData = new FormData(event.currentTarget);
        // Introducing lint rule banning type assertions
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const email = formData.get('email') as string | null;
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          if (isFooCorpEmail(email ?? '')) {
            setScreen('sso-redirect');
          } else {
            setScreen('password');
          }
        }, 1000);
        event.preventDefault();
      }}>
          <Flex direction="column" gap="5">
            <Heading trim="start">Sign in to Demo App</Heading>

            <DemoForm.Field name="email">
              <DemoForm.Label>Email</DemoForm.Label>
              <DemoForm.Input required placeholder="Enter email address" readOnly={screen !== 'email'} type="email" />
              <DemoForm.Message match="valueMissing">
                Email is required
              </DemoForm.Message>
              <DemoForm.Message match="typeMismatch">
                Email should be valid.
              </DemoForm.Message>
            </DemoForm.Field>

            <DemoForm.Submit loading={loading}>Continue</DemoForm.Submit>
          </Flex>
        </DemoForm.Root>
      </ChromeUI>;
  }
  if (screen === 'password') {
    return <ChromeUI>
        <DemoForm.Root onSubmit={event => {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          setScreen('password-success');
        }, 1000);
        event.preventDefault();
      }}>
          <Flex direction="column" gap="5">
            <Heading trim="start">Sign in to Demo App</Heading>

            <DemoForm.Field name="email">
              <DemoForm.Label>Email</DemoForm.Label>
              <DemoForm.Input readOnly required placeholder="Enter email address" type="email" />
              <DemoForm.Message match="valueMissing">
                Email is required
              </DemoForm.Message>
              <DemoForm.Message match="typeMismatch">
                Email should be valid.
              </DemoForm.Message>
            </DemoForm.Field>

            <DemoForm.Field name="password">
              <DemoForm.Label>Password</DemoForm.Label>
              <DemoForm.Input autoFocus required placeholder="Enter password" type="password" />
              <DemoForm.Message match="valueMissing">
                Password is required
              </DemoForm.Message>
            </DemoForm.Field>

            <DemoForm.Submit loading={loading}>Continue</DemoForm.Submit>
          </Flex>
        </DemoForm.Root>
      </ChromeUI>;
  }
  if (screen === 'password-success') {
    return <PasswordEndScreen onRestart={handleRestart} />;
  }
  if (screen === 'sso-redirect') {
    return <SsoEndScreen onRestart={handleRestart} />;
  }
  return null;
};
const SsoDynamicPasswordField = () => {
  const [loading, setLoading] = React.useState(false);
  const [screen, setScreen] = React.useState<'initial' | 'sso-redirect' | 'password-success'>('initial');
  const [email, setEmail] = React.useState('');
  const isFooCorp = isFooCorpEmail(email);
  const handleRestart = () => {
    setEmail('');
    setScreen('initial');
  };
  if (screen === 'initial') {
    return <ChromeUI>
        <DemoForm.Root onSubmit={event => {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          setScreen(isFooCorp ? 'sso-redirect' : 'password-success');
        }, 1000);
        event.preventDefault();
      }}>
          <Flex direction="column" gap="5">
            <Heading trim="start">Sign in to Demo App</Heading>
            <DemoForm.Field name="email">
              <DemoForm.Label>Email</DemoForm.Label>
              <DemoForm.Input required placeholder="Enter email address" type="email" value={email} onChange={event => setEmail(event.target.value)} />
              <DemoForm.Message match="valueMissing">
                Email is required
              </DemoForm.Message>
              <DemoForm.Message match="typeMismatch">
                Email should be valid.
              </DemoForm.Message>
            </DemoForm.Field>

            {isFooCorp ? null : <DemoForm.Field name="password">
                <DemoForm.Label>Password</DemoForm.Label>
                <DemoForm.Input required disabled={isFooCorp} placeholder="Enter password" type="password" />
                <DemoForm.Message match="valueMissing">
                  Password is required
                </DemoForm.Message>
              </DemoForm.Field>}

            <DemoForm.Submit loading={loading}>
              Continue{isFooCorp ? ' with SSO' : ''}
            </DemoForm.Submit>
          </Flex>
        </DemoForm.Root>
      </ChromeUI>;
  }
  if (screen === 'password-success') {
    return <PasswordEndScreen onRestart={handleRestart} />;
  }
  if (screen === 'sso-redirect') {
    return <SsoEndScreen onRestart={handleRestart} />;
  }
  return null;
};
const ChromeUI = (props: React.ComponentProps<typeof Card>) => <Theme asChild hasBackground={false} panelBackground="solid" data-sentry-element="Theme" data-sentry-component="ChromeUI" data-sentry-source-file="sso-demos.tsx">
    <Box maxWidth="368px" position="relative" width="100%" data-sentry-element="Box" data-sentry-source-file="sso-demos.tsx">
      <Box inset="0" m="1" position="absolute" style={{
      borderRadius: 'var(--radius-4)',
      boxShadow: 'var(--shadow-6)'
    }} data-sentry-element="Box" data-sentry-source-file="sso-demos.tsx" />
      <Card size="3" {...props} data-sentry-element="Card" data-sentry-source-file="sso-demos.tsx" />
    </Box>
  </Theme>;
const PasswordEndScreen = ({
  onRestart
}: {
  onRestart: () => void;
}) => <ChromeUI data-sentry-element="ChromeUI" data-sentry-component="PasswordEndScreen" data-sentry-source-file="sso-demos.tsx">
    <Flex align="center" direction="column" gap="3" justify="center" minHeight="254px" data-sentry-element="Flex" data-sentry-source-file="sso-demos.tsx">
      <Heading trim="start" data-sentry-element="Heading" data-sentry-source-file="sso-demos.tsx">You are signed in</Heading>
      <Button autoFocus size="3" onClick={() => onRestart()} data-sentry-element="Button" data-sentry-source-file="sso-demos.tsx">
        Start over
      </Button>
    </Flex>
  </ChromeUI>;
const SsoEndScreen = ({
  onRestart
}: {
  onRestart: () => void;
}) => <ChromeUI data-sentry-element="ChromeUI" data-sentry-component="SsoEndScreen" data-sentry-source-file="sso-demos.tsx">
    <Flex align="center" direction="column" gap="3" justify="center" minHeight="170px" data-sentry-element="Flex" data-sentry-source-file="sso-demos.tsx">
      <Text align="center" as="p" color="gray" data-sentry-element="Text" data-sentry-source-file="sso-demos.tsx">
        The user is redirected to&nbsp;their&nbsp;SSO&nbsp;provider
      </Text>
      <Button autoFocus size="3" onClick={() => onRestart()} data-sentry-element="Button" data-sentry-source-file="sso-demos.tsx">
        Start over
      </Button>
    </Flex>
  </ChromeUI>;
const isFooCorpEmail = (email: string) => email.endsWith('@foo-corp.com');